import { useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { DeleteConfirmationModal } from '../../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import { ALERT_TEXT } from '../../../../constants/content';
import { useAlert } from '../../../../context/Alert.context';
import { GadgetDto } from '../../../../types/gadgets.types';

interface DeleteGadgetModalProps {
  open: boolean;
  onClose: () => void;
  item: GadgetDto;
  updateGadgetAfterDelete: () => void;
}

export const DeleteGadgetModal = ({
  open,
  onClose,
  item,
  updateGadgetAfterDelete,
}: DeleteGadgetModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const onDelete = () => {
    setLoading(true);
    API.delete(`${URLS.GADGETS}/${item.id}`)
      .then((res) => {
        updateGadgetAfterDelete();
        onClose();
        showAlert({
          message: ALERT_TEXT.GADGET_DELETE_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setLoading(false));
  };

  return (
    <DeleteConfirmationModal
      loading={loading}
      onClose={onClose}
      open={open}
      titleItem={item.name}
      onDelete={onDelete}
    />
  );
};
